import { render, staticRenderFns } from "./setpwd.vue?vue&type=template&id=e726d5c4&scoped=true"
import script from "./setpwd.vue?vue&type=script&lang=js"
export * from "./setpwd.vue?vue&type=script&lang=js"
import style0 from "./setpwd.vue?vue&type=style&index=0&id=e726d5c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e726d5c4",
  null
  
)

export default component.exports